<onsip-header-main>
  <onsip-header-page-title>E911</onsip-header-page-title>
  <onsip-header-action-bar>
    <mat-form-field appearance="outline">
      <input
        matInput
        [formControl]="search"
        [placeholder]="'ONSIP_I18N.SEARCH' | translate"
        autocomplete="off"
      />
      <mat-icon color="primary" matSuffix>search</mat-icon>
    </mat-form-field>
    <button
      mat-stroked-button
      onsip-header-secondary-action
      color="primary"
      (click)="openAddLocationModal()"
      class="e911-add-location"
    >
      {{ "ONSIP_I18N.ADD_LOCATION" | translate }}
    </button>
  </onsip-header-action-bar>
</onsip-header-main>

<onsip-loading-container [deferCond]="isDataObtained$">
  <onsip-table-two
    multiTemplateDataRows
    [dataSource]="dataSource"
    class="e911-table"
    [trackBy]="trackByLocationId"
    [useGrid]="true"
    [hoverable]="true"
  >
    <!-- Location Name Column -->
    <ng-container matColumnDef="locationName">
      <mat-header-cell *matHeaderCellDef>{{
        "ONSIP_I18N.LOCATION_NAME" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let location">
        <span class="e911-location-name">{{ location.locationName }}</span>
      </mat-cell>
    </ng-container>
    <!-- Location Address Column -->
    <ng-container matColumnDef="locationAddress">
      <mat-header-cell *matHeaderCellDef>
        <span class="e911-erl">
          {{ "ONSIP_I18N.EMERGENCY_RESPONSE_LOCATION" | translate }}
          &nbsp;
          <mat-icon
            class="e911-help-icon"
            matTooltip="Enables users to specify their exact location so emergency calls can be routed to the correct 911 center."
            matTooltipClass="onsip-tooltip-background"
            matTooltipPosition="above"
          >
            help_outline
          </mat-icon>
        </span>
      </mat-header-cell>
      <mat-cell *matCellDef="let location">
        <span class="e911-full-address">{{ location.fullAddress }}</span>
      </mat-cell>
    </ng-container>
    <!-- Address Type Column -->
    <ng-container matColumnDef="addressType">
      <mat-header-cell *matHeaderCellDef>{{
        "ONSIP_I18N.ADDRESS_TYPE" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let location">{{ location.locationType }}</mat-cell>
    </ng-container>
    <!-- Assigned User Column -->
    <ng-container matColumnDef="assignedUser">
      <mat-header-cell *matHeaderCellDef>{{
        "ONSIP_I18N.ASSIGNED_USERS" | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let location">{{ location.assignedAddressCount }}</mat-cell>
    </ng-container>
    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let location">
        @if (selectedRows.includes(location.e911LocationId)) {
        <mat-icon color="primary">expand_less</mat-icon>
        } @if (!selectedRows.includes(location.e911LocationId)) {
        <mat-icon color="primary">expand_more</mat-icon>
        }
        <button mat-icon-button (click)="$event.stopPropagation(); removeItem(location)">
          <mat-icon color="primary">delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <!-- Expanded Shelf -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let location"
        [attr.colspan]="displayedColumns.length"
        [expanded]="selectedRows.includes(location.e911LocationId)"
      >
        @if (selectedRows.includes(location.e911LocationId)) {
        <onsip-admin-e911-table-shelf-container
          [e911Location]="location"
          [userAddressE911Info]="userAddressE911Info$"
        >
        </onsip-admin-e911-table-shelf-container>
        }
      </onsip-table-shelf-cell>
    </ng-container>
    <mat-header-row
      class="e911-table-header-row"
      *matHeaderRowDef="displayedColumns"
    ></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="
        selectedRows.includes(row.e911LocationId)
          ? selectedRows.splice(selectedRows.indexOf(row.e911LocationId), 1)
          : selectedRows.push(row.e911LocationId)
      "
    >
    </mat-row>
    <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
    <div *matNoDataRow class="no-data-row">
      @if (dataSource.data; as locations) { @if (!locations.length || !search.value) {
      <span
        translate
        [translateParams]="{ value: 'ONSIP_I18N.E911_LOCATION' | translate | lowercase }"
      >
        ONSIP_I18N.YOU_HAVENT_ADDED_ANY_VALUE_YET
      </span>
      } @if (search.value && locations.length) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      } }
    </div>
  </onsip-table-two>
  <div class="download-btn-container">
    <a
      mat-stroked-button
      color="primary"
      href="https://cdn2.hubspot.net/hubfs/516769/E911-warning-labels.pdf"
      target="_blank"
    >
      <mat-icon color="primary" class="download-icon">file_download</mat-icon>
      <span>{{ "ONSIP_I18N.DOWNLOAD_WARNING_LABELS" | translate }}</span>
    </a>
  </div>
  <span class="mat-body-2 contact-support"
    >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
    <a class="support-link" [routerLink]="[views.CONTACT_SUPPORT]">
      {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
    </a>
  </span>
</onsip-loading-container>
